export const ApiRoutes = {
  API_HOSTNAME: process.env.REACT_APP_API_ENDPOINT,
  MEDIA_BASE_URL: process.env.REACT_APP_API_ENDPOINT,
  // API_HOSTNAME:"http://192.168.1.111:5010",
  WHATSAPP_URL: process.env.REACT_APP_WHATSAPP_URL,
  WS_HOSTNAME: process.env.REACT_APP_WEB_SOCKET_URL,
  API_HOSTNAME_WP: process.env.REACT_APP_HOSTNAME_WP,
  API_HOSTNAME_CONNECT_CRM: process.env.REACT_APP_CONNECT_CRM,
  // WS_SECOND_HOSTNAME: process.env.REACT_APP_WEB_SOCKET_SECOND_URL,
  WAPMONKEY_WS_HOST: process.env.REACT_APP_WAP_SOCKET_URL,

  LOGIN: "login",
  GETSOP: "getsop",
  LOGOUT: "logout",
  SENDSMS: "sendsms",
  GETTODO: "gettodo",
  GET_CITY: "getcity",
  GET_STATE: "getstate",
  GETCOLOR: "getcolor",
  GETNOTES: "getnotes",
  INSERTSOP: "insertsop",
  UPDATESOP: "updatesop",
  INSERTFILTER: "insertfilter",
  DELETEFILTER: "deletefilter",
  SETDEFAULTFILTER: "setdefaultfilter",
  GETFILTER: "getfilter",
  MERGECUSTOMER: "mergecustomer",
  DELETESOP: "deletesop",
  SENDEMAIL: "sendemail",
  CHECKEMAIL: "checkemail",
  DELETELEAD: "deletelead",
  GET_COUNTRY: "getcountry",
  UPDATELEAD: "updatelead",
  IMPORTLEAD: "importlead",
  INSERTLEAD: "insertlead",
  INSERTTASK: "inserttask",
  UPDATETASK: "updatetask",
  DELETETASK: "deletetask",
  UPDATETODO: "updatetodo",
  DELETETODO: "deletetodo",
  INSERTTODO: "inserttodo",
  DELETEUNIT: "deleteunit",
  DELETELEAD: "deletelead",
  DELETENOTE: "deletenotes",
  GETHOLIDAYS: "getholiday",
  INSERTCOLOR: "insertcolor",
  DELETECOLOR: "deletecolor",
  INSERTNOTES: "insertnotes",
  UPDATENOTES: "updatenotes",
  GETTEMPLATE: "gettemplate",
  INSERTLEAVE: "insertleave",
  UPDATELEAVE: "updateleave",
  GETCUSTOMERBYID: "getcustomerbyid",
  GETCHATLIST: "getchatlist",
  INSERTEVENT: "insertevent",
  DELETEEVENT: "deleteevent",
  UPDATEEVENT: "updateevent",
  GLOBALSEARCH: "globalsearch",
  TESTMAILSEND: "testmailsend",
  INSERTPAYMENT: "insertpayment",
  UPDATEPAYMENT: "updatepayment",
  // GET_CUSTOMER_DETAILS: "getcustomerdetails",
  GETCHATGROUP: "getchatgroup",
  GETLEAVELIST: "getleavedata",
  GETEMAILSETTING: "getemailsetting",
  GETTODAYLEAD: "gettodaylead",
  UPDATEINVOICE: "updateinvoice",
  GETCAMPAIGN: "v1/getcampaign",
  INSERTHOLIDAY: "insertholiday",
  INSERTSERVICE: "insertservice",
  UPDATESERVICE: "updateservice",
  DELETESERVICE: "deleteservice",
  UPDATEHOLIDAY: "updateholiday",
  DELETEHOLIDAY: "deleteholiday",
  ADDDEPARTMENT: "adddepartment",
  DELETECUSTOMER: "deletecustomer",
  IMPORT_CUSTOMER: "importcustomer",
  UPDATEFBTOKEN: "updatefbtoken",
  SENDEMAIL: "sendmailtocustomer",
  GETATTRIBUTES: "getattributes",
  GETCUSTOMTODO: "getcustomtodo",
  WAPMONKEYLINK: "linktowapmonkey",
  GETPROFILEDATA: "getprofiledata",
  CHANGEPASSWORD: "changepassword",
  CANCELINVOICE: "cancelinvoice",
  GETINVOICELIST: "getinvoicelist",
  UPDATEREMINDER: "updatereminder",
  GETNOTIFACTION: "getnotifaction",
  INSERT_CUSTOMER: "insertcustomer",
  GETDEPARTMENTS: "getdepartments",
  GETLEADHISTORY: "getleadhistory",
  INSERTTEMPLATE: "inserttemplate",
  UPDATETEMPLATE: "updatetemplate",
  DELETETEMPLATE: "deletetemplate",
  GETALLTODOLIST: "getalltodolist",
  GETTASKHISTORY: "gettaskhistory",
  REQUESTTOSTAFF: "requesttostaff",
  GETMETASTAFF: "api/getmetastaff",
  GENERATEINVOICE: "generateinvoice",
  WAPGETUSERDEVICE: "getuserdevice",
  PENDINGTODOLIST: "getpendingtodo",
  GETTODOREPORT: "customtodoreport",
  SEND_MESSAGE_V1: "v1/sendmessage",
  DOWNLOADINVOICE: "downloadinvoice",
  INSERT_CUSTOMER: "insertcustomer",
  GETTASKCOMMENT: "gettaskcomments",
  GETQUOTATIONLIST: "getquotationlist",
  ADDCUSTOMERATTACHMENT: "addcustomerattachment",
  WAPDEVICELOGOUT: "apidevicelogout",
  WPCHECKACCOUNT: "checkuseraccount",
  INSERTATTRIBUTE: "insertattribute",
  UPDATEATTRIBUTE: "updateattribute",
  GETLEADFOLLOWUP: "getleadfollowup",
  CHECKLEADMOBILE: "checkleadmobile",
  GETREMINDERBYCUSTOMER: "getreminderbycid",
  UPDATELEADLABEL: "updateleadlabel",
  DELETEATTRIBUTE: "deleteattribute",
  GETSTAFFFORCHAT: "getstaffforchat",
  INSERTCHATGROUP: "insertchatgroup",
  UPDATELEADLABEL: "updateleadlabel",
  CHECKTRIPEXISTS: "checktripexists",
  UPDATETASKLABELS: "updatetasklabel",
  UPDATETODOLABELS: "updatetodolabel",
  INSERTCAMPAIGN: "v1/insertcampaign",
  DELETECAMPAIGN: "v1/deletecampaign",
  DELETEDEPARTMENT: "deletedepartment",
  GETSTAFFLOGINOTP: "getstaffloginotp",
  DELETECAMPAIGN: "v1/deletecampaign",
  GETREMINDERBYCID: "getreminderbycid",
  GETDASHBOARDTASK: "getdashboardtask",
  UPDATEDEPARTMENT: "updatedepartment",
  GETREMINDERANDMEETING: "getreminder",
  UPDATELEADSTATUS: "updateleadstatus",
  INSERTCUSTOMTODO: "insertcustomtodo",
  UPDATETODOSTATUS: "updatetodostatus",
  DELETECUSTOMTODO: "deletecustomtodo",
  READNOTIFICATION: "readnotification",
  TRANSFERUSERDATA: "transferuserdata",
  INSERTTEMPLATEV1: "inserttemplate/v1",
  UPDATETEMPLATEV1: "updatetemplate/v1",
  SENDMAILTOCUSTOMER: "sendmailtocustomer",
  LINK_TO_WAP_MONKEY: "linktowapmonkey",
  WAPMONKEYREGISTRATION: "registration",
  GETACTIVECUSTOMER: "getactivecustomer",
  GETCALENDEREVENT: "getcalenderevents",
  DOWNLOADINVOICEZIP: "downloadzipinvoice",
  INSERTTODOCOMMENT: "inserttodocomment",
  UPDATETODOCOMMENT: "updatetodocomment",
  DELETETODOCOMMENT: "deletetodocomment",
  GETMEETINGHISTORY: "getmeetinghistory",
  GETUSERLISTBYDEPT: "getuserlistbydept",
  UPDATEPROFILEDATA: "updateprofiledata",
  UPDATENOTIFACTION: "updatenotifaction",
  GETUSERPERMISSION: "getuserpermission",
  GETSERVICEHISTORY: "getservicehistory",
  INSERTTASKCOMMENT: "inserttaskcomment",
  UPDATELEAVESTATUS: "updateleavestatus",
  INSERTEMAILSETTING: "insertemailsetting",
  DELETEEMAILSETTING: "deleteemailsetting",
  ASSIGNEMAILSETTING: "assignemailsetting",
  GETUSERBYDEPTANDUNITWISE: "getuserlist",
  UPDATETODOPOSITION: "updatetodoposition",
  INSERTLEADASSIGNTO: "insertleadassignto",
  DELETEMULTIPLETASK: "deletemultipletask",
  UPDATETASKASSIGNTO: "updatetaskassignto",
  GETFIRSTLEVELCHILD: "getfirstlevelchild",
  GETCUSTOMERDETAILS: "getcustomerdetails",
  INSERTSTAFFCHECKIN: "insertstaffcheckin",
  GETAUTOMATIONRULES: "getautomationrules",
  CUSTOMERTAGCOUNTER: "customertagcounter",
  GETTASKATTACHMENT: "getattachmentdatabyid",
  ASSIGNTAGTOCUSTOMER: "assigntagtocustomer",
  CHECKWAPMONKEYACCOUNT: "checkuseraccount",
  GETSTAFFDEPTWISESOP: "getstaffdeptwisesop",
  DELETEREMINDERORMEETING: "deletereminder",
  UPDATEREMINDERORMEETING: "updatereminder",
  GETDELAYTASKREPORT: "gettasktdelayreport",
  GETCHECKINOUTONFIELD: "getcheckinoutonfield",
  GETLEADCOUNTERBYCID: "getleadcounterbycid",
  GETCHATGROUPDETAILS: "getchatgroupdetails",
  INSERTREMINDERANDMEETING: "insertreminder",
  UPDATEMEETINGSTATUS: "updatemeetingstatus",
  UPDATESTAFFCHECKOUT: "updatestaffcheckout",
  ADDORGANIZATIONUNIT: "addorganizationunit",
  GETORGANIZATIONUSER: "getorganizationuser",
  GETCAMPAIGNREPORT: "/v1/getcampaignreport",
  GETORGANIZATIONUNIT: "getorganizationunit",
  INSERTRECURSIVETODO: "insertrecursivetodo",
  UPDATERECURSIVETODO: "updaterecursivetodo",
  UPDATESERVICESTATUS: "updateservicestatus",
  UPDATECAMPAIGN: "v1/updatecampaigndetails",
  DELETERECURSIVETODO: "deleterecursivetodo",
  READALLNOTIFICATION: "read-allnotification",
  GETCAMPAIGNDETAILS: "v1/getcampaigndetails",
  ADDORGANIZATIONSTAFF: "addorganizationuser",
  UPDATEEMAILSETTING: "updateemailsetting",
  GETCUSTOMERHISTORYBYID: "getcustomerhistory",
  INSERTLEADFOLLOWUP: "v1/insertleadfollowup",
  GETLABELWISETASKREPORT: "gettasklabelreport",
  ADDSERVICEATTACHMENT: "addserviceattachment",
  GETTEMPLATECATEGORY: "gettemplatecategory",
  GETLABELWISELEADREPORT: "getleadlabelreport",
  DELETELEADATTACHMENT: "deleteleadattachment",
  DELETESOPATTACHMENT: "deletesopattachment",
  ASSIGNTOMULTIPLELEAD: "assigntomultiplelead",
  UPDATECAMPAIGNSTATUS: "updatecampaignstatus",
  PRODUCTSUGGESTIONLIST: "productsuggestionlist",
  SYNCWAPMONKEYMETATEMPLATE: "syncwpmetatemplate",
  CHANGEFORGOTPASSWORD: "changeforgotpassword",
  INSERTUSERPERMISSION: "insertuserpermission",
  UPDATEUSERPERMISSION: "updateuserpermission",
  DELETETASKATTACHMENT: "deletetaskattachment",
  GETALLCUSTOMTODOLIST: "getallcustomtodolist",
  GETCUSTOMTODOCOMMENT: "getcustomtodocomment",
  DELETEPACKAGEREQUEST: "deletepackagerequest",
  UPDATEPACKAGEREQUEST: "updatepackagerequest",
  CHECK_WAP_MONKEY_ACCOUNT: "checkuseraccount",
  GETCELEBRATIONREMINDER: "getcelebrationreminder",
  UPDATEDEPTSETTINGS: "updatedepartmentsetting",
  WAPREMAININGCREDITAPI: "remaining-credit-api",
  WAPMONKEYSENDTESTMESSAGE: "testwpmessagesend",
  UPDATERECURSIVECUSTOMTODO: "updatecustomtodo",
  GETNOTIFICATIONDETAILS: "getnotificationdetails",
  API_CHECK_REGISTER_OTP: "apicheckregisterotp",
  GET_USER_DEVICE_API_V1: "v1/getuserdeviceapi",
  CHECKATTENDANCEPASSWORD: "checkattendancepwd",
  GETCUSTOMERRATINGRULE: "getcustomerratingrule",
  GETSTATUSWISETASKREPORT: "gettaskstatusreport",
  DELETE_AUTOMATION_RULE: "delete-automationRule",
  GETINVOICEDETAILBYID: "getinvoicedetailbyid",
  GETSOURCEWISELEADREPORT: "getleadsourcereport",
  GETSTATUSWISELEADREPORT: "getleadstatusreport",
  UPDATECUSTOMERSTATUS: "updatecustomerstatus",
  GETPACKAGEREQUESTLIST: "getpackagerequestlist",
  GET_STORE_WEB_SETTING: "getorganizationunitbyid",
  SEARCHALLLEADPAGINATE: "searchallleadpaginate",
  SEARCHALLTASKPAGINATE: "searchalltaskpaginate",
  GETWAPMONKEYMETATEMPLATE: "getwpmetatemplate",
  GETTEMPLATEDETAILSBYID: "gettemplatedetailsbyid",
  LEADCONVERTTOCUSTOMER: "leadconverttocustomer",
  GETTEMPLATEBYCATEGORY: "gettemplatebycategory",
  GETUSERPERMISSIONBYID: "getuserpermissionbyid",
  INSERTLEADINQUIRYFORM: "insertleadinquiryform",
  INSERTAUTOMATIONRULES: "insertautomationrules",
  UPDATEAUTOMATIONRULES: "updateautomationrules",
  DELETEAUTOMATIONRULES: "deleteautomationrules",
  UPDATECUSTOMERDETAILS: "updatecustomerdetails",
  UPDATESTAFFATTENDANCE: "updatestaffattendance",
  GETDATAFORINQUIRYFORM: "getdataforinquiryform",
  GETSTAFFATTENDANCEREPORT: "getattendancereport",
  GETCOMPANYWEBSETTING: "getorganizationunitbyid",
  UPDATEORGANIZATIONUNIT: "updateorganizatonunit",
  DELETETEMPLATEATTACHMENT: "deleteemailattachment",
  GETREMINDERDETAILSBYID: "getreminderdetailbyid",
  UPDATEORGANIZATIONUSER: "updateorganizatonuser",
  WAPMONKEYCHECKREGISTEROTP: "check-register-otp",
  UPDATEATTENDANCEPASSWORD: "updateattendancepwd",
  UPDATECUSTOMTODOLABELS: "updatecustomtodolabel",
  REGISTRATIONVALIDATION: "registrationvalidation",
  GETLEADSTATUSCHARTDATA: "getleadstatuschartdata",
  INSERTUSERSOPAGREEMENT: "insertusersopagreement",
  GETLEADSOURCECHARTDATA: "getleadsourcechartdata",
  SENDWPMESSAGETOCUSTOMER: "sendwpmessagetocustomer",
  UPDATECUSTOMTODOSTATUS: "updatecustomtodostatus",
  INSERTRESCHDULEMEETING: "insertreschdulemeeting",
  DELETEMULTIPLEREMINDER: "deletemultiplereminder",
  GETSTAFFCHECKINOUTDATA: "getstaffcheckinoutdata",
  UPDATEMULTIPLELEADLABEL: "updatemultipleleadlabel",
  GETCUSTOMTODOATTECHMENT: "getcustomtodoattechment",
  UPDATESERVICEASSIGNUSER: "changeserviceassignuser",
  DELETESERVICEATTACHMENT: "deleteserviceattachment",
  ALLOCATELEADLABELASSIGN: "allocateleadlabelassign",
  ALLOCATELEADLABELASSIGN: "allocateleadlabelassign",
  CHECKSUBDEPARTMENTEXIST: "checksubdepartmentexist",
  GETALLDEPARTMENTFORTREE: "getalldepartmentfortree",
  GETDEPARTMENTDETAILBYID: "getdepartmentdetailbyid",
  INSERTCUSTOMTODOCOMMENT: "insertcustomtodocomment",
  DELETECUSTOMTODOCOMMENT: "deletecustomtodocomment",
  UPDATECUSTOMTODOCOMMENT: "updatecustomtodocomment",
  GETPRIORITYWISETASKREPORT: "gettasktpriorityreport",
  GETREMINDERWISEASSIGNUSER: "getreminderassignusers",
  UPDATECOMPANYWEBSETTINGS: "updatecompanywebsetting",
  SYNCCAMPAIGNREPORTBYDATE: "synccampaignreportbydate",
  DELETECUSTOMERATTACHMENT: "deletecustomerattachment",
  UPDATE_AUTOMATION_RULES_V1: "v1/updateautomationRules",
  INSERT_AUTOMATION_RULES_V1: "v1/insertautomationRules",
  GETUSERLISTBYUNITANDDEPT: "getuserlistbyunitanddept",
  GETUSERLISTFORATTENDANCE: "getuserlistforattendance",
  IMPORTCELEBRATIONREMINDER: "importcelebrationreminder",
  UPDATEMULTIPLELEADSTATUS: "updatemultipleleadstatus",
  GETALLSTAFFCHECKINOUTONFIELD: "getcheckinoutonfield",
  UPDATECUSTOMERRATINGRULES: "updatecustomerratingrules",
  STAFFMONTHLYATTENDANCE: "staffmonthlyattendancereport",
  INSERTCELEBRATIONREMINDER: "insertcelebrationreminder",
  UPDATECELEBRATIONREMINDER: "updatecelebrationreminder",
  DELETECELEBRATIONREMINDER: "deletecelebrationreminder",
  UPDATESTAFFATTENDANCENOTE: "updatestaffattendancenote",
  REQUESTPACKAGETOMAINADMIN: "requestpackagetomainadmin",
  GETSTAFFWISESERVICEREPORT: "getstaffwiseservicereport",
  UPDATEPACKAGESTATUSCHANGE: "updatepackagestatuschange",
  GETDASHBOARDREMINDERANDMEETING: "getreminderdashboard",
  GETLEADLINKSMODULECOUNTER: "getleadlinksmodulecounter",
  REMOVESTAFFWPDEVICENUMBER: "removestaffwpdevicenumber",
  UPDATESTAFFWPDEVICENUMBER: "updatestaffwpdevicenumber",
  GETUSERLISTFORSTAFFTRANSFER: "getuserforstafftransfer",
  GETFOLLOWUPWISELEADREPORT: "getleadfollowupwisererport",
  DELETECAMPAIGNATTACHMENT: "v1/deletecampaignattachment",
  INSERTMULTIPLELEADASSIGNTO: "insertmultipleleadassignto",
  DELETECUSTOMTODOATTACHMENT: "deletecustomtodoattechment",
  GETSTATUSWISESERVICEREPORT: "getstatuswiseservicereport",
  GETCELEBRATIONREMINDERBYCID: "getcelebrationreminderbycid",
  REGISTRATION_WITH_WAP_MONKEY: "registrationwithwapmonkey",
  INSERT_WABA_AUTOMATION_RULES: "insertwabaautomationRules",
  UPDATE_WABA_AUTOMATION_RULES: "updatewabaautomationRules",
  DELETEMULTIPLEREMINDERORMEETING: "deletemultiplereminder",
  UPDATE_AUTOMATION_RULES_STATUS: "updateautomationrulesstatus",
  GET_ALL_CUSTOMER_FOR_QUOTATION: "getallcustomerforquotation",
  LEADFOLLOWUPWISEUSERREPORT: "getleadfollowupuserwisereport",
  UPDATEORGANIZATIONUNITSTATUS: "updateorganizatonunitstatus",
  GETTHIRDPARTYSWISELEADREPORT: "getleadthirdpartywiseRerport",
  GETCUSTOMERWISESERVICEREPORT: "getcustomerwiseservicereport",
  GET_AUTOMATION_RULES_BY_STORE: "get-automationRulesByStore",
  GETORGANIZATIONUSERFORCHART: "getorganizationuserfororgchart",
  SENDPAYMENTREMINDERONWHATSAPP: "sendpaymentreminderonwhatsapp",
  GETCUSTOMERWISEFOLLOWUPREPORT: "getcustomerwisefollowupreport",
  GETREQUESTPACKAGETOMAINADMIN: "getrequestpackagetomainadmin",
  UPDATEORGANIZATIONSTAFFSTATUS: "updateorganizatonuserstatus",
  ATTENDANCEINSERTSTAFFCHECKIN: "attendance-insertstaffcheckin",
  UPDATESTAFFATTENDANCENOTETYPE: "updatestaffattendancenotetype",
  ATTENDANCEUPDATESTAFFCHECKOUT: "attendance-updatestaffcheckout",
  GETMISSINGFOLLOWUPREMINDERLIST: "getmissingfollowupreminderlist",
  GETSTAFFWISEDELAYSERVICEREPORT: "getstaffwisedelayservicereport",
  UPDATETHIRDPARTYINTEGRATION: "updatecompanythirdpartyintegration",
  DELETEREQUESTPACKAGETOMAINADMIN: "deleterequestpackagetomainadmin",
  UPDATEREQUESTPACKAGETOMAINADMIN: "updateRequestPackageToMainAdmin",
  UPDATETEMPLATEATTACHMENTCAPTION: "updatetemplateattachmentcaption",
  GETTASKORMEETINGSTAFFTRIPWITHPOINTS: "gettaskormettingstafftripwithpoints",
  GETMONTHORYEARWISELEADSTATUSREPORT: "getleadstatusmonthoryearwisereport",
  ATTENDANCEGETUSERLISTFORATTENDANCE: "attendance-getuserlistforattendance",
  GETSTAFFWISESOPREPORT: "getstaffwisesopreport",
  GETSERVICELISTWITHPAGINATIONANDFILTER:
    "getservicelistwithpaginationandfilter",
  GETSTAFFLOGINOTP: "getstaffloginotp",
  GETCOUNTRIESLIST: "getcountrieslist",
  INSERTPAYMENTMETHOD: "insertpaymentmethod",
  UPDATEPAYMENTMETHOD: "updatepaymentmethod",
  DELETEPAYMENTMETHOD: "deletepaymentmethod",
  GETPAYMENTMETHOD: "getpaymentmethod",
  INSERTBROUCHER: "insertbrouchure",
  UPDATEBROUCHER: "updatebrouchure",
  DELETEBROUCHER: "deletebrouchure",
  GETBROUCHER: "getbrouchure",
  GETCATEGORYTEMPLATELIST: "getcategorytemplatelist",
  GETTASKDETAILSBYID: "gettaskdetailsbyid",
};
